import React, { useCallback, useState } from 'react';
import { validateIdentification } from '../interact';
import TextFieldWithButton from './ui/TextFieldWithButton';
import { useTranslation } from 'react-i18next';
import { registerEvent } from '../utils/google-analytics.js';
import Accordion from '@mui/material/Accordion';
import { Arrow } from './Faqs.jsx';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CheckImg from '../assets/images/certificates/check_cloud.png';

export default function DocumentValidator({ certificate, styleColor }) {
    const [documentValid, setDocumentValid] = useState(null);
    const [document, setDocument] = useState('');
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const loadingTexts = ['loading.step1_id'];
    const handleDocument = useCallback(() => {
        setLoading(true);
        validateIdentification(certificate, document)
            .then((x) => setDocumentValid(x))
            .finally(() => setLoading(false));
        registerEvent('validate-document');
    });

    const handleDocumentChange = useCallback((e) => {
        setDocumentValid(null);
        setDocument(e.target.value);
    });

    return (
        <Accordion
            sx={{
                borderRadius: 4,
                margin: 0,
                boxShadow: 0,
                padding: 0,
                border: '1px solid rgba(0, 0, 0, 0.2)',
                '&:before': {
                    display: 'none',
                },
            }}
        >
            <AccordionSummary
                expandIcon={<Arrow />}
                sx={{ '&.MuiAccordionSummary-root': { alignItems: 'baseline !important' }, overflow: 'auto' }}
            >
                <Stack direction="row" spacing={1}>
                    <img src={CheckImg} alt="check" height={24} loading="lazy" />
                    <Stack>
                        <Typography variant="caption" fontWeight={700} mt={-0.5}>
                            {t('certificate.enter_document_title')}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.7, lineHeight: '18px' }}>
                            {t('certificate.enter_document')}
                        </Typography>
                    </Stack>
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ '&.MuiAccordionDetails-root': { paddingTop: 0 } }}>
                <Stack spacing={1}>
                    <TextFieldWithButton
                        text={t('certificate.enter_document_label')}
                        validatedText={t('certificate.id_number_validated')}
                        onSubmit={handleDocument}
                        status={documentValid}
                        styleColor={styleColor}
                        value={document}
                        key="document"
                        loading={loading}
                        loadingTexts={loadingTexts}
                        errorText={t('certificate.document_error')}
                        onChange={handleDocumentChange}
                    />
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}
